(() => {
  const script = document.currentScript;
  const formId = script?.dataset.formId || '1175760';
  const delay = Math.max(0, Number(script?.dataset.delay) || 5000);
  const designMode = script?.dataset.designMode === 'true';
  const key = `mw-forms-${formId}-seen`;
  const selector = `shopify-forms-embed#app-embed-container-${formId}`;
  const start = () => {
    let ready = false;
    let seen = false;
    let opening = false;
    let focused = false;
    let restoreFocus = null;
    let host = null;
    let shadowObserver = null;
    try { seen = sessionStorage.getItem(key) === 'yes'; } catch {}
    const remember = () => {
      if (seen) return;
      seen = true;
      try { sessionStorage.setItem(key, 'yes'); } catch {}
    };
    const update = () => {
      const root = host?.shadowRoot;
      if (!root) return;
      const step = root.querySelector('[data-current-step]')?.dataset.currentStep;
      if (host.inert === ready) host.inert = !ready;
      if (!ready || designMode) return;
      if (step === 'success') { remember(); return; }
      if (step === 'form') {
        remember();
        if (!focused) {
          focused = true;
          requestAnimationFrame(() => root.querySelector('input')?.focus({ preventScroll: true }));
        }
        return;
      }
      if (step === 'tease' && !seen && !opening) {
        const teaser = root.querySelector('[data-testid="form-teaser"]');
        if (teaser) {
          opening = true;
          restoreFocus = document.activeElement;
          teaser.click();
        }
      }
    };
    const bind = () => {
      const next = document.querySelector(selector);
      if (!next?.shadowRoot || next === host) { update(); return; }
      shadowObserver?.disconnect();
      host = next;
      observer.disconnect();
      const root = host.shadowRoot;
      const style = document.createElement('style');
      style.dataset.mwTeaserHidden = 'true';
      style.textContent = '[data-current-step="tease"],[data-testid="form-teaser"]{display:none!important}';
      root.append(style);
      root.addEventListener('click', event => {
        if (!event.composedPath().some(node => node instanceof Element && node.getAttribute('aria-label') === 'Close modal')) return;
        remember();
        requestAnimationFrame(() => { if (restoreFocus?.isConnected) restoreFocus.focus({ preventScroll: true }); });
      }, true);
      shadowObserver = new MutationObserver(update);
      shadowObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-current-step'] });
      update();
    };
    const observer = new MutationObserver(bind);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => {
      ready = true;
      document.documentElement.classList.remove('mw3-forms-delay');
      bind();
      if (host) host.inert = false;
      update();
    }, designMode ? 0 : delay);
    bind();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
